import { useState, useCallback, useEffect, useMemo } from 'react';
import axios from 'axios';

const baseUrl = process.env.NODE_ENV === 'production' ? `api.${process.env.REACT_APP_SERVER_HOST}` : process.env.REACT_APP_SERVER_HOST;
const protocol = process.env.REACT_APP_HTTPS === 'true' ? 'https://' : 'http://';

const useApi = (method, route, body, opt) => {
  const [bodyState] = useState(body);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const options = useMemo(() => opt || {}, [opt]);

  const fetchData = useCallback(async () => {
    options.withCredentials = true;
    const url = `${protocol}${baseUrl}/${route}`;
    try {
      let response;
      if (method === 'POST') {
        response = await axios.post(url, bodyState, options);
      } else {
        response = await axios.get(url, options);
      }
      setData(response.data);
    } catch (error) {
      const axiosError = error;
      setError(axiosError);
    } finally {
      setLoading(false);
    }
  }, [route, method, bodyState]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!opt?.refetchInterval || opt?.refetchInterval == 0) {
      return;
    }

    const interval = setInterval(() => {
      fetchData();
    }, opt.refetchInterval);

    return () => clearInterval(interval);
  }, []);

  return { data, loading, error, refetch: fetchData };
};

export default useApi;
